let flagsPromise: Promise<Record<string, boolean>> | null = null;

const fetchFlags = (): Promise<Record<string, boolean>> => {
  if (!flagsPromise) {
    flagsPromise = fetch(`${import.meta.env.CUSTOMER_API_URL}/v1/flags`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Flag fetch failed: ${response.status}`);
        }
        return response.json();
      })
      .catch(error => {
        flagsPromise = null;
        throw error;
      });
  }
  return flagsPromise;
};

/**
 * Evaluate a feature flag.
 * Returns the default value if the key is missing or fetch fails.
 */
export const getFlag = async (
  flagKey: string,
  defaultValue: boolean
): Promise<boolean> => {
  try {
    const flags = await fetchFlags();
    return flagKey in flags ? flags[flagKey] : defaultValue;
  } catch {
    return defaultValue;
  }
};
